const template = `
    <nav>Navigation</nav>
`;

export default window.Handlebars.compile(template);
